import { call, put, takeLatest } from 'redux-saga/effects';
import { API } from '../api';
import { FETCH_FLEET_USER_GROUP_PRICING, CREATE_FLEET_USER_GROUP_PRICING, DELETE_FLEET_USER_GROUP_PRICING, UPDATE_FLEET_USER_GROUP_PRICING, GET_FLEET_USER_GROUP_PRICING } from 'actions/fleetPricing';

function* fetchFleetUserGroupPricing(action) {
  try {
    const response = yield call(API.getFleetUserGroupPricing, action.payload);
    yield put({ type: FETCH_FLEET_USER_GROUP_PRICING.SUCCESS, payload: response.data });
    action.cb && action.cb(response);
  } catch (e) {
    yield put({ type: FETCH_FLEET_USER_GROUP_PRICING.FAIL, payload: { error: e } });
  }
}

function* getFleetUserGroupPricing(action) {
  try {
    const response = yield call(API.getFleetUserGroupPricingById, action.payload);
    yield put({ type: GET_FLEET_USER_GROUP_PRICING.SUCCESS, payload: response.data });
  } catch (e) {
    yield put({ type: GET_FLEET_USER_GROUP_PRICING.FAIL, payload: { error: e } });
  }
}

function* createFleetUserGroupPricing(action) {
  try {
    const response = yield call(API.addFleetUserGroupPricing, action.payload);
    yield put({ type: CREATE_FLEET_USER_GROUP_PRICING.SUCCESS, payload: response.data });
    action.cb && action.cb(response);
  } catch (e) {
    yield put({ type: CREATE_FLEET_USER_GROUP_PRICING.FAIL, payload: { error: e } });
    action.cb && action.cb(e);
  }
}

function* updateFleetUserGroupPricing(action) {
  try {
    const response = yield call(API.updateFleetUserGroupPricing, action.payload);
    yield put({ type: UPDATE_FLEET_USER_GROUP_PRICING.SUCCESS, payload: response.data });
    action.cb && action.cb(response);
  } catch (e) {
    yield put({ type: UPDATE_FLEET_USER_GROUP_PRICING.FAIL, payload: { error: e } });
    action.cb && action.cb(e);
  }
}

function* deleteFleetUserGroupPricing(action) {
  try {
    const response = yield call(API.deleteFleetUserGroupPricing, action.payload);
    yield put({ type: DELETE_FLEET_USER_GROUP_PRICING.SUCCESS, payload: action.payload });
    action.cb && action.cb(response);
  } catch (e) {
    yield put({ type: DELETE_FLEET_USER_GROUP_PRICING.FAIL, payload: { error: e } });
    action.cb && action.cb(e);
  }
}

function* fleetUserGroupPricing() {
  yield takeLatest(FETCH_FLEET_USER_GROUP_PRICING.REQUEST, fetchFleetUserGroupPricing);
  yield takeLatest(GET_FLEET_USER_GROUP_PRICING.REQUEST, getFleetUserGroupPricing);
  yield takeLatest(CREATE_FLEET_USER_GROUP_PRICING.REQUEST, createFleetUserGroupPricing);
  yield takeLatest(UPDATE_FLEET_USER_GROUP_PRICING.REQUEST, updateFleetUserGroupPricing);
  yield takeLatest(DELETE_FLEET_USER_GROUP_PRICING.REQUEST, deleteFleetUserGroupPricing);
}
export default fleetUserGroupPricing;
